import React from 'react';
import { PlusOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { Namespace, usePermissions } from '@data';
import { Button, AntdTypography } from '@ui/components';

const { Text } = AntdTypography;

type AddDependencyProps = {
  onAddDependsOnClick: () => void;
  question: string;
};

export const AddDependency = ({ question, onAddDependsOnClick }: AddDependencyProps) => {
  const { t } = useTranslation([Namespace.ADMIN]);
  const { IS_REVIEWER } = usePermissions();

  return (
    <div className="flex flex-col gap-1 items-center w-full p-4">
      <Button
        ghost
        size="large"
        type="dashed"
        disabled={!question || IS_REVIEWER}
        icon={<PlusOutlined />}
        onClick={onAddDependsOnClick}
        className="text-primary-600 border-primary-600 disabled:text-base-600 disabled:border-base-600 rounded-sm h-full px-6 py-4"
      >
        {t('question_page.details.dependencies.add_depends_on')}
      </Button>
      <div className="w-[1px] h-6 bg-base-600" />
      <div className="p-4 bg-base-100 rounded-default border-solid border-primary-600">
        <Text className="text-xl font-medium">{question}</Text>
      </div>
    </div>
  );
};
